/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import { SsoTableSsoFragmentDoc } from '../../../../../components/organization/SsoTable/__generated__/SsoTable.graphql';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type OrganizationSsoIndexPageQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type OrganizationSsoIndexPageQuery = { __typename: 'Query', organization: { __typename: 'Organization', id: string, ssos: Array<{ __typename: 'Sso', id: string, domain: string, verificationStatus: Types.DomainVerificationStatus, provider?: { __typename: 'OidcProvider', displayName?: string | null, strategy: Types.SsoProviderStrategy, validationStatus?: Types.SsoValidationStatus | null, options: { __typename: 'OidcOptions', clientId?: string | null, clientSecret?: string | null, issuer?: string | null, discoveryUrl?: string | null, authorizationEndpoint?: string | null, jwksUri?: string | null } } | { __typename: 'SamlProvider', displayName?: string | null, strategy: Types.SsoProviderStrategy, validationStatus?: Types.SsoValidationStatus | null, options: { __typename: 'SamlOptions', entityId?: string | null, signInEndpoint?: string | null, signingCert?: string | null } } | null }> } };

export type DomainCreateMutationVariables = Types.Exact<{
  domain: Types.Scalars['String'];
}>;


export type DomainCreateMutation = { __typename: 'Mutation', ssoDomainCreate: { __typename: 'Sso', id: string, domain: string } };


export const OrganizationSsoIndexPageDocument = gql`
    query OrganizationSsoIndexPage {
  organization {
    id
    ssos {
      ...SsoTableSso
    }
  }
}
    ${SsoTableSsoFragmentDoc}`;

/**
 * __useOrganizationSsoIndexPageQuery__
 *
 * To run a query within a React component, call `useOrganizationSsoIndexPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationSsoIndexPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationSsoIndexPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useOrganizationSsoIndexPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<OrganizationSsoIndexPageQuery, OrganizationSsoIndexPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<OrganizationSsoIndexPageQuery, OrganizationSsoIndexPageQueryVariables>(OrganizationSsoIndexPageDocument, options);
      }
export function useOrganizationSsoIndexPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<OrganizationSsoIndexPageQuery, OrganizationSsoIndexPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<OrganizationSsoIndexPageQuery, OrganizationSsoIndexPageQueryVariables>(OrganizationSsoIndexPageDocument, options);
        }
export type OrganizationSsoIndexPageQueryHookResult = ReturnType<typeof useOrganizationSsoIndexPageQuery>;
export type OrganizationSsoIndexPageLazyQueryHookResult = ReturnType<typeof useOrganizationSsoIndexPageLazyQuery>;
export type OrganizationSsoIndexPageQueryResult = ApolloReactCommon.QueryResult<OrganizationSsoIndexPageQuery, OrganizationSsoIndexPageQueryVariables>;
export const DomainCreateDocument = gql`
    mutation DomainCreate($domain: String!) {
  ssoDomainCreate(input: {domain: $domain}) {
    id
    domain
  }
}
    `;
export type DomainCreateMutationFn = ApolloReactCommon.MutationFunction<DomainCreateMutation, DomainCreateMutationVariables>;

/**
 * __useDomainCreateMutation__
 *
 * To run a mutation, you first call `useDomainCreateMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDomainCreateMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [domainCreateMutation, { data, loading, error }] = useDomainCreateMutation({
 *   variables: {
 *      domain: // value for 'domain'
 *   },
 * });
 */
export function useDomainCreateMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DomainCreateMutation, DomainCreateMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DomainCreateMutation, DomainCreateMutationVariables>(DomainCreateDocument, options);
      }
export type DomainCreateMutationHookResult = ReturnType<typeof useDomainCreateMutation>;
export type DomainCreateMutationResult = ApolloReactCommon.MutationResult<DomainCreateMutation>;
export type DomainCreateMutationOptions = ApolloReactCommon.BaseMutationOptions<DomainCreateMutation, DomainCreateMutationVariables>;